import React from "react"
import PropTypes from "prop-types"

import { numero } from "../format"

/**
 * Producto y granja donde lo pedido supera lo ofertado. La zona es la de
 * origen: una disponibilidad atiende a varias regiones de destino a la vez, así
 * que no se puede repartir el faltante entre destinos.
 */
const DeficitCard = ({ deficit, sinCubrir }) => (
  <div className="res-deficit res-anim">
    <div>
      <h3>
        <i className="bx bx-error me-1"></i>
        Déficit de producto
      </h3>
      <div className="res-deficit-total">
        <span>{numero(sinCubrir)}</span>
        <small>kg sin abasto</small>
      </div>
    </div>

    {deficit.length > 0 ? (
      <div className="res-deficit-list">
        {deficit.map((fila, indice) => (
          <div className="res-deficit-row" key={`${fila.producto}-${indice}`}>
            <span>
              {fila.producto}
              {fila.zona ? ` · ${fila.zona}` : ""}
            </span>
            <span>{numero(fila.kgs)} kg</span>
          </div>
        ))}
      </div>
    ) : (
      <div className="res-deficit-row">
        <span>Todos los pedidos del día tienen abasto.</span>
      </div>
    )}
  </div>
)

DeficitCard.propTypes = {
  deficit: PropTypes.array.isRequired,
  sinCubrir: PropTypes.number,
}

export default DeficitCard
